import { connect, MapStateToProps, MapDispatchToProps } from 'react-redux';
import { AppState } from '../../../../../types/store';
import { PostsType, JournalFilterType } from '../../../../../types/posts';
import { getPostsDeviationsStreamId } from '../../../../streams/posts';

import {
  selectors as streamSelectors,
  withOffset,
} from '@wix/da-shared-react/pkg/Stream';

import { getDeviationsByIds } from '@wix/da-shared-react/pkg/redux/deviations/selectors';
import { Props } from './Journals';

type StateProps = Pick<
  Props,
  | 'streamId'
  | 'journals'
  | 'featuredJournals'
  | 'hasMoreJournals'
  | 'hasMoreFeaturedJournals'
  | 'isFetchingJournals'
  | 'isFetchingFeaturedJournals'
>;

type DispatchProps = Pick<
  Props,
  'fetchMoreJournals' | 'fetchMoreFeaturedJournals'
>;

type OwnProps = Omit<Props, keyof (StateProps & DispatchProps)>;

const mapStateToProps: MapStateToProps<StateProps, OwnProps, AppState> = (
  state,
  ownProps
) => {
  const journalsStreamId = getPostsDeviationsStreamId({
    type: PostsType.JOURNALS,
    sortOrder: ownProps.sortOrder,
  });
  const featuredJournalsStreamId = getPostsDeviationsStreamId({
    type: PostsType.JOURNALS,
    filter: JournalFilterType.FEATURED,
  });
  const journals = getDeviationsByIds(
    state,
    streamSelectors.getItems(state, journalsStreamId)
  );

  const featuredJournals = getDeviationsByIds(
    state,
    streamSelectors.getItems(state, featuredJournalsStreamId)
  );

  return {
    streamId: journalsStreamId,
    journals,
    featuredJournals,
    hasMoreJournals: streamSelectors.hasMore(state, journalsStreamId),
    hasMoreFeaturedJournals: streamSelectors.hasMore(
      state,
      featuredJournalsStreamId
    ),
    isFetchingJournals: streamSelectors.isFetching(state, journalsStreamId),
    isFetchingFeaturedJournals: streamSelectors.isFetching(
      state,
      featuredJournalsStreamId
    ),
  };
};

const mapDispatchToProps: MapDispatchToProps<DispatchProps, OwnProps> = (
  dispatch,
  ownProps
) => {
  const journalsStreamId = getPostsDeviationsStreamId({
    type: PostsType.JOURNALS,
    sortOrder: ownProps.sortOrder,
  });
  const featuredJournalsStreamId = getPostsDeviationsStreamId({
    type: PostsType.JOURNALS,
    filter: JournalFilterType.FEATURED,
  });
  return {
    fetchMoreJournals: () =>
      dispatch(withOffset.actions.fetch(journalsStreamId)),
    fetchMoreFeaturedJournals: () =>
      dispatch(withOffset.actions.fetch(featuredJournalsStreamId)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps);
